const getters = {
  language: state => state.app.language,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  menu: state => state.user.menu,
  uploadeToken: state => state.qiniu.uploadeToken,
  createdAt: state => state.qiniu.createdAt,
  searchKey: state => state.searchKey.searchKey
  // roles: state => state.user.roles
}
export default getters
